import { IconArrowLeft } from '@tabler/icons-react'
import { ReactNode } from 'react'

import { AstraButton, AstraHeading, AstraIcon, AstraParagraph, astraTwMerge } from '~/astra'
import { DialogCrumb } from '~/components/DialogBreadcrumbsHeader'

export const FormContentWrapper = ({ title, children }: { title: ReactNode; children: ReactNode }) => (
    <section className="flex flex-col gap-6 rounded-lg bg-surface-base">
        <AstraHeading as="h2" className="flex items-center gap-2">
            {title}
        </AstraHeading>
        <div className="flex flex-col gap-10">{children}</div>
    </section>
)

export const FormPageWrapper = ({ children, backCrumb }: { backCrumb?: DialogCrumb; children: ReactNode }) => (
    <div className="flex w-full flex-col gap-4 pb-8">
        {backCrumb && (
            <AstraButton variant="ghost" icon={<AstraIcon icon={IconArrowLeft} />} size="large" onClick={backCrumb.onClick} label={backCrumb.title} />
        )}
        <div className="flex w-full max-w-[768px] flex-col gap-6 self-center">{children}</div>
    </div>
)

export const FieldGroupWrapper = ({ children, className }: { children: ReactNode; className?: string }) => (
    <div className={astraTwMerge('grid items-start gap-4 sm:grid-cols-2', className)}>{children}</div>
)

export type FormSectionWrapperProps = {
    children: ReactNode
    title?: ReactNode
    titleAction?: ReactNode
    description?: string
    className?: string
    noBorder?: boolean
    noPadding?: boolean
    afterTitle?: ReactNode
    variant?: 'default' | 'magic'
    size?: 'compact' | 'default'
}

export const FormSectionWrapper = ({
    children,
    title,
    titleAction,
    description,
    className,
    noBorder = false,
    noPadding = false,
    afterTitle,
    variant = 'default',
    size = 'default',
}: FormSectionWrapperProps) => (
    <section className={astraTwMerge('flex flex-col gap-3', className)}>
        <div className="flex items-center justify-between gap-4">
            {title && (
                <div className="flex items-center gap-2">
                    <AstraParagraph variant={size === 'compact' ? 'body' : 'body-large'} weight="medium" className="text-default">
                        {title}
                    </AstraParagraph>
                    {afterTitle}
                </div>
            )}
            {titleAction}
        </div>
        {description && size !== 'compact' && <AstraParagraph className="text-muted">{description}</AstraParagraph>}
        <div
            className={astraTwMerge(
                `flex flex-col gap-5 rounded-lg ${variant === 'magic' ? 'border-dashed border-magic-subtle bg-purple-50/40' : 'border-base'} ${noPadding ? 'p-0' : 'p-4'} ${noBorder ? 'border-none' : 'border'}`
            )}
        >
            {children}
        </div>
    </section>
)
